// extracted by extract-css-chunks-webpack-plugin
module.exports = {"showChosenFromList":"_30GXyO aLs3Nr","open":"_3xBY5Y","heading":"_2Lzop0","content":"_3BxogU","resultCta":"_3B64rS","contentMarkup":"_24ryko"};